import { Link, useNavigate } from "react-router-dom";
import { ServerCrash } from "lucide-react";

export function Error500Page() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#eceff3] px-6 py-12">
      <div className="mx-auto flex max-w-3xl flex-col items-center justify-center">
        <div className="w-full overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-2xl">
          <div className="border-b border-slate-200 bg-white px-8 py-6">
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-rose-50 text-rose-600">
                <ServerCrash className="h-5 w-5" />
              </div>
              <div>
                <h1 className="text-lg font-semibold text-slate-900">Ocurrió un error</h1>
                <p className="mt-0.5 text-sm text-slate-500">
                  No pudimos completar la acción. Intenta nuevamente.
                </p>
              </div>
            </div>
          </div>

          <div className="px-8 py-8">
            <p className="text-sm text-slate-600">
              Si el problema persiste, revisa tu conexión o vuelve más tarde.
            </p>

            <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
              <button
                type="button"
                onClick={() => navigate(0)}
                className="h-11 rounded-full border border-slate-300 bg-white px-6 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
              >
                Reintentar
              </button>
              <Link
                to="/"
                className="inline-flex h-11 items-center justify-center rounded-full bg-primary px-8 text-sm font-semibold text-white transition hover:bg-primary-hover"
              >
                Ir al inicio
              </Link>
            </div>
          </div>
        </div>

        <p className="mt-6 text-center text-xs text-slate-400">
          Código: 500
        </p>
      </div>
    </div>
  );
}
